import fonts from './fonts';

const BaseStyles = theme => ({
  fonts,
  body: {
    margin: 0,
    backgroundColor: theme.palette.background.default,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize,
    color: theme.palette.text.primary,
  },
  a: {
    fontFamily: theme.typography.bold.fontFamily,
    color: theme.palette.primary.main,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'none',
      color: theme.palette.button.textHover,
    },
    '&:active, &:focus, &:focus-visible': {
      color: theme.palette.button.textHover,
      textDecoration: 'underline',
      outline: 'none',
    },
    '&.button-link': {
      borderRadius: theme.border.radius,
      border: `1px solid ${theme.palette.primary.main}`,
      backgroundColor: theme.palette.primary.light,
      padding: '10px 12px',
      color: theme.palette.primary.main,
      fontFamily: theme.typography.bold.fontFamily,
      textDecoration: 'none',
      display: 'flex',
      alignItems: 'center',
      '&:hover': {
        backgroundColor: theme.palette.primary.light2,
        color: theme.palette.primary.main,
        textDecoration: 'none',
      },
      '&:active, &:focus, &:focus-visible': {
        backgroundColor: theme.palette.primary.light2,
        color: theme.palette.primary.main,
        textDecoration: 'underline',
        outline: 'none',
      },
      '&:disabled': {
        color: theme.palette.text.disabled,
        borderColor: theme.palette.text.disabled,
        backgroundColor: theme.palette.background.default,
      },
      '&--warning': {
        borderColor: theme.palette.warning.main,
        backgroundColor: theme.palette.warning.light,
        color: theme.palette.warning.main,
        '&:hover': {
          backgroundColor: theme.palette.warning.light2,
          color: theme.palette.warning.main,
        },
        '&:active, &:focus, &:focus-visible': {
          backgroundColor: theme.palette.warning.light2,
          color: theme.palette.warning.main,
          textDecoration: 'underline',
          outline: 'none',
        },
      },
    },
  },
  button: {
    '&:focus-visble': {
      outline: 'none',
    },
  },
});

export default BaseStyles;
